import { updateUnauthorizedHostConfig } from 'APP/Tasks/config/updateUnauthorizedHostConfig';

import { resetHostConfig } from './resetHostConfig';
import { updateHostConfig } from './updateHostConfig';

export default {
  updateHostConfig,
  resetHostConfig,
  updateUnauthorizedHostConfig,
};
